import API from './resources';

const actions = {
  async postUserLogin({ commit }, payload) {

    try {
      const response = await API.postUserLogin(payload)
      commit('SET_SESSION', response.data.token)
      return response
    } catch (error) {
      return error.response
    }
  },
  async getUserDetails({ commit }, token) {
    try {
      const response = await API.getUserDetails(token)
      commit('SET_USER_DETAILS', response.data)
      return response
    } catch (error) {
      return error.response
    }
  },
  async userLogout({ commit }, token) {
    try {
      const response = await API.postUserLogout(token)
      commit('CLEAR_TOKEN')
      commit('SET_USER_DETAILS', {})
      return response
    } catch (error) {
      return error.response
    }
  },
  async getRoles({ commit }, token) {
    try {
      const response = await API.getRolesUser(token)
      commit('SET_ROLES_USER', response.data)
      return response
    } catch (error) {
      return error.response
    }
  },
}

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/users/actions.js